import {
  call,
  put,
  take,
  fork,
  cancel,
  takeLatest,
  select,
} from 'redux-saga/effects';
import { eventChannel, END } from 'redux-saga';
import { subscribeToMarketingUpdates } from '../utils/appSyncService';
import {
  updateMarketingBanner,
  hideMarketingBanner,
  START_MARKETING_SUBSCRIPTION,
} from '../ducks/marketingBanner';
import { setError, clearError, setMaintenance } from '../ducks/error';
import { errorSelector } from '../reducers/selectors';

/**
 * Creates an event channel for AppSync marketing subscription
 */
function createMarketingSubscriptionChannel() {
  return eventChannel((emitter) => {
    const subscription = subscribeToMarketingUpdates(
      (marketingData) => {
        emitter(marketingData);
      },
      (error) => {
        console.error('Marketing subscription error:', error);
        emitter(END);
      },
    );

    // Return unsubscribe function
    return () => {
      if (subscription) {
        subscription.unsubscribe();
      }
    };
  });
}

/**
 * Saga to handle marketing banner subscription
 */
function* watchMarketingSubscription() {
  let channel;
  try {
    channel = yield call(createMarketingSubscriptionChannel);
    while (true) {
      const marketingData = yield take(channel);
      const error = yield select(errorSelector);
      // Check if this is a hide action
      if (marketingData.action === 'hide') {
        yield put(hideMarketingBanner());
        if (error.get('maintenanceMode')) {
          yield put(clearError());
        }
        continue;
      }

      // Handle show action - check if banner is within valid date range
      const now = new Date();
      const startDate = new Date(marketingData.startDate);
      const endDate = new Date(marketingData.endDate);

      // If maintenance mode is enabled, trigger a global error route
      if (marketingData.maintenanceMode) {
        const message = marketingData.message;
        yield put(setMaintenance(message, true));
      } else {
        yield put(clearError());
      }

      // if (now >= startDate && now <= endDate) {
      yield put(updateMarketingBanner(marketingData));
      //  }
    }
  } catch (error) {
    console.error('Marketing subscription saga error:', error);
  } finally {
    if (channel) {
      channel.close();
    }
  }
}

/**
 * Root saga for AppSync subscriptions
 */
export default function* appSyncSaga() {
  yield takeLatest(START_MARKETING_SUBSCRIPTION, watchMarketingSubscription);
}
